/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { all } from 'redux-saga/effects';

import {
  watchInitedSettings,
  watchSettingsModuleLoaded
} from './initialize.validation.settings.saga';
import watchSaveValidationPluginSettings, { watchStatefulPluginSaved } from './save.validation.plugins.settings.saga';
import {
  watchUpdatePluginConfig,
  watchToggleUserUsesOrg
} from './save.view.plugins.saga';
import watchUpdateValidationSettings from './update.validation.plugin.settings.saga';

export default function* settingsViewSaga() {
  yield all([
    watchInitedSettings(),
    watchSettingsModuleLoaded(),
    watchSaveValidationPluginSettings(),
    watchStatefulPluginSaved(),
    watchUpdatePluginConfig(),
    watchUpdateValidationSettings(),
    watchToggleUserUsesOrg()
  ]);
}
